var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00022 1.48242L17.103 9.58522C17.2748 9.75705 17.2748 10.0356 17.103 10.2075C16.9312 10.3793 16.6526 10.3793 16.4808 10.2075L9.00022 2.72693L1.51968 10.2075C1.34785 10.3793 1.06926 10.3793 0.897428 10.2075C0.725597 10.0356 0.725597 9.75705 0.897428 9.58522L9.00022 1.48242Z",
    fill: "#08081B",
    stroke: "#007C92",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.b3ed384c81d20f0fd42c053d1052c540.svg";
export { ForwardRef as ReactComponent };